<template>
  <div>
    <button
      :class="{ active }"
      class="responsive-nav-link w-full text-left rounded-none"
      v-if="as == 'button'"
    >
      <slot></slot>
    </button>

    <subdomain-link
      :href="href"
      :root="root"
      :target="target"
      :class="{ active }"
      class="responsive-nav-link"
      v-else
    >
      <slot></slot>
    </subdomain-link>
  </div>
</template>

<script>
  export default {
    props: {
      href: String,
      as: { type: String, default: 'link' },
      active: {
        type: Boolean,
        default: false,
      },
      root: {
        type: Boolean,
        default: false,
      },
      target: {
        type: String,
        default: '_self',
      },
    },
  };
</script>

<style scoped>
  .active {
    @apply text-primary-600;
  }
</style>
